import {Model} from 'vue-mc';
import * as dateMethods from "@/helpers/date-methods";

export class EjecucionExtemporaneaModel extends Model{
  defaults() {
    return {
      comerciosId : []
      , tipoEjecucion : ''
      
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      comerciosId : comerciosId=> comerciosId
      , tipoEjecucion: tipoEjecucion=> tipoEjecucion
    }
  }

  // Attribute validation
  validation() {
    return {
    }
  }

  // Model Options
  options() {
    return {
      validateOnSave     : false
      , validateOnChange   : false 
      , validateRecursively: false
    }
  }
}


// WEBPACK FOOTER //
// ./src/models/seguimiento/scheduled/ejecucion-extemporanea.js